import React from 'react';

export const setIconActive = (e: React.MouseEvent<HTMLDivElement>) => {
  const target = e.currentTarget.querySelector('.header_icon_gabrr');
  return target?.classList.toggle('active');
};

export const usersListFilter = (textInput, items) => {
  const shortTxt = (text) => {
    return text
      ?.toLowerCase()
      .normalize('NFD')
      .replace(/[\s()]/gi, '');
  };

  const textToLowerNoSpace = shortTxt(textInput);

  const parsedList = items?.map((user) => {
    const { user_name, user_pk, email, docNumber } = user;

    return {
      hits: {
        code: shortTxt(user_name) + user_pk + docNumber + email,
        user,
      },
    };
  });

  return parsedList
    ?.map((item) => {
      return new RegExp(textToLowerNoSpace, 'gi').test(item.hits.code) && item.hits.user;
    })
    .filter((res) => res !== false);
};

export const cpGroupsListFilter = (textInput, items) => {
  const shortTxt = (text) => {
    return text?.toLowerCase().replace(/\s/gi, '');
  };

  const textToLowerNoSpace = shortTxt(textInput);

  const parsedList = items?.map((cpGroups) => {
    const { name } = cpGroups;
    return {
      hits: {
        code: shortTxt(name), // + shortText(newFieldToBeSearchedToo)
        cpGroups,
      },
    };
  });

  return parsedList
    ?.map((item) => {
      return new RegExp(textToLowerNoSpace, 'gi').test(item.hits.code) && item.hits.cpGroups;
    })
    .filter((res) => res !== false);
};

export const alertsListFilter = (textInput, items) => {
  const shortTxt = (text) => {
    return text?.toLowerCase().replace(/\s/gi, '');
  };

  const textToLowerNoSpace = shortTxt(textInput);

  const parsedList = items?.map((notification) => {
    const { chargeBoxName } = notification;
    return {
      hits: {
        code: shortTxt(chargeBoxName), // + shortText(newFieldToBeSearchedToo)
        notification,
      },
    };
  });

  return parsedList
    ?.map((item) => {
      return new RegExp(textToLowerNoSpace, 'gi').test(item.hits.code) && item.hits.notification;
    })
    .filter((res) => res !== false);
};

export const transactionsListFilter = (textInput, items) => {
  const shortTxt = (text) => {
    return text?.toLowerCase().replace(/\s/gi, '');
  };

  const textToLowerNoSpace = shortTxt(textInput);

  const parsedList = items?.map((transaction) => {
    const { chargeBoxDescription, id, chargeBoxId } = transaction;
    return {
      hits: {
        code: shortTxt(chargeBoxDescription) + shortTxt(chargeBoxId) + id, // + shortText(newFieldToBeSearchedToo)
        transaction,
      },
    };
  });

  return parsedList
    ?.map((item) => {
      return new RegExp(textToLowerNoSpace, 'gi').test(item.hits.code) && item.hits.transaction;
    })
    .filter((res) => res !== false);
};
